import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './BenefitsSection.styles';
import { messageFormatValues } from '../../utils/messageFormatValues';

const DEFAULT_ICON_COLOR = 'success.dark';

export function BenefitsItem({ item }) {
  return (
    <Styled.BenefitItem>
      <Stack gap={2}>
        {item.icon && (
        <Styled.Icon sx={{ backgroundColor: item.iconBgColor }}>
          <SharedAsset alt="" src={item.icon} color={item.iconColor || DEFAULT_ICON_COLOR} width="100%" />
        </Styled.Icon>
        )}
        <Stack gap={1}>
          {item.title && <Heading size="md"><FormattedMessage id={item.title} /></Heading>}
          {item.description && (
          <Text color="secondary">
            <FormattedMessage
              id={item.description}
              values={messageFormatValues}
            />
          </Text>
          )}
        </Stack>
      </Stack>
    </Styled.BenefitItem>
  );
}

BenefitsItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    iconBgColor: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string
  }).isRequired
};
